const form = {
	formID: "customer",
	formField: {
		name: {
			name: "name",
			label: "customerForm.name.label",
			requiredMessage: "customerForm.name.requiredMessage",
		},
		code: {
			name: "code",
			label: "customerForm.code.label",
			requiredMessage: "customerForm.code.requiredMessage",
		},
		companyID: {
			name: "companyID",
			label: "customerForm.companyID.label",
			requiredMessage: "customerForm.companyID.requiredMessage",
		},
	},
};

export default form;
